export default __webpack_public_path__ + "static/media/ausgefülltes_formular1024_1.498c0832.jpg";